import { NgModule } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarModule } from 'primeng/sidebar';
import { TabMenuModule } from 'primeng/tabmenu';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TreeModule } from 'primeng/tree';
import { MenuModule } from 'primeng/menu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenubarModule } from 'primeng/menubar';
import { BadgeModule } from 'primeng/badge';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AccordionModule } from 'primeng/accordion';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DialogService } from 'primeng/dynamicdialog';
import { DragDropModule } from 'primeng/dragdrop';
import { GalleriaModule } from 'primeng/galleria';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService, MessageService } from 'primeng/api';
import { OrderListModule } from 'primeng/orderlist';
import { EditorModule } from 'primeng/editor';
import { SliderModule } from 'primeng/slider';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';

const primeComponents = [
  PanelModule,
  TableModule,
  SidebarModule,
  TabMenuModule,
  InputTextareaModule,
  CheckboxModule,
  CalendarModule,
  DialogModule,
  DynamicDialogModule,
  TabViewModule,
  TooltipModule,
  DropdownModule,
  MultiSelectModule,
  ButtonModule,
  InputTextModule,
  DividerModule,
  ConfirmDialogModule,
  OverlayPanelModule,
  TreeModule,
  MenuModule,
  AutoCompleteModule,
  SplitButtonModule,
  MenubarModule,
  BadgeModule,
  ContextMenuModule,
  ScrollPanelModule,
  AccordionModule,
  ConfirmPopupModule,
  RadioButtonModule,
  ScrollPanelModule,
  DragDropModule,
  GalleriaModule,
  OrderListModule,
  EditorModule,
  SliderModule,
  ProgressBarModule,
  ToastModule,
  InputNumberModule,
];

@NgModule({
  imports: primeComponents,
  exports: primeComponents,
  providers: [DialogService, ConfirmationService, MessageService],
  declarations: [],
})
export class PrimeNgModule {}
